module.exports = __webpack_public_path__ + "@/assets/img/fingerprint.baebdd2a.svg";